module.exports = __webpack_public_path__ + "static/event-hub-location-32e81dc91bd1de4c028b35fa1e6d87a6.png";